import { ActionIcon, Tooltip } from "@mantine/core"
import { IconPencil, IconPencilBolt } from "@tabler/icons-react"
import _ from "lodash"
import { RuleGroupType } from "react-querybuilder"

import { BillyResponses } from "@costory/types/endpoints/billy"
import { Position } from "@costory/types/endpoints/digest"
import { DatePreset } from "@costory/types/prisma-client"

import { getdeterministicNodeId } from "@costory/shared/utils/digest"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { useBilly } from "@costory/front/pages/DigestV2/components/SuggestedCards/hooks/useBilly"

export const BillyAvailable = ({
  position,
  datePreset,
  period,
  exclusionWhereClause,
  costColumn,
  cannotEditContext,
  onClick,
}: {
  position: Position
  datePreset: DatePreset
  period: string
  exclusionWhereClause: RuleGroupType
  costColumn: string
  cannotEditContext: boolean
  onClick: () => void
}) => {
  const { queryContributionAnalysis, queryHistoryOfCosts } = useBilly({
    position,
    datePreset,
    period,
    exclusionWhereClause,
    costColumn,
  })
  return (
    <QueryWrapper
      query={queryContributionAnalysis}
      allowEmptyArray
      defaultData={[]}
    >
      {({ data: contributionAnalysis }) => (
        <QueryWrapper
          query={queryHistoryOfCosts}
          allowEmptyArray
          defaultData={[]}
        >
          {({ data: historyOfCosts }) => (
            <_Component
              cannotEditContext={cannotEditContext}
              onClick={onClick}
              contributionAnalysis={contributionAnalysis}
              historyOfCosts={historyOfCosts}
              position={position}
            />
          )}
        </QueryWrapper>
      )}
    </QueryWrapper>
  )
}

const _Component = ({
  cannotEditContext,
  onClick,
  contributionAnalysis,
  historyOfCosts,
  position,
}: {
  cannotEditContext: boolean
  onClick: () => void
  contributionAnalysis: BillyResponses.ContributionAnalysisAvailable[]
  historyOfCosts: BillyResponses.ContributionAnalysisAvailable[]
  position: Position
}) => {
  const lastVersionContributionAnalysis = _(
    contributionAnalysis.filter(
      (item) =>
        getdeterministicNodeId(item.whereClause) ==
        getdeterministicNodeId(position),
    ),
  )
    .sortBy("updatedAt")
    .reverse()
    .value()[0]
  const lastVersionHistoryOfCosts = _(
    historyOfCosts.filter(
      (item) =>
        getdeterministicNodeId(item.whereClause) ==
        getdeterministicNodeId(position),
    ),
  )
    .sortBy("updatedAt")
    .reverse()
    .value()[0]
  const isRunning =
    lastVersionContributionAnalysis?.status === "PENDING" ||
    lastVersionHistoryOfCosts?.status === "PENDING"
  const isFailed =
    lastVersionContributionAnalysis?.status === "FAILED" ||
    lastVersionHistoryOfCosts?.status === "FAILED"
  const isCompleted =
    lastVersionContributionAnalysis?.status === "COMPLETED" ||
    lastVersionHistoryOfCosts?.status === "COMPLETED"
  return (
    <Tooltip label="Edit context" disabled={cannotEditContext} position="top">
      <ActionIcon
        disabled={cannotEditContext}
        onClick={onClick}
        variant="transparent"
        color={
          isRunning
            ? "green"
            : isFailed
              ? "red"
              : isCompleted
                ? "green"
                : "gray"
        }
        style={{
          position: "absolute",
          right: "12vw",
          top: "10px",
          cursor: "pointer",
        }}
        data-intercom-target="costory-tour-digest-node-edit-icon"
      >
        {isRunning ? <IconPencilBolt size={20} /> : <IconPencil size={20} />}
      </ActionIcon>
    </Tooltip>
  )
}
